import React from 'react';

export default function SectionHeader({ title, subtitle, action }) {
  return (
    <div className="mb-5 pb-4 border-b border-gray-100">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-base font-bold text-k-h">{title}</h3>
          {subtitle && (
            <p className="text-sm text-gray-400 mt-1 max-w-lg">{subtitle}</p>
          )}
        </div>
        {action}
      </div>
    </div>
  );
}
